export const SPACE_ACTION_TYPES = {
  LOAD_SPARES_SUCCESS: 'LOAD_SPARES_SUCCESS'
};
